<template>
  <div class="main-view">
    <el-table :show-header="false" :data="noticeList" class="table">
      <el-table-column prop="details">
        <template slot-scope="scope">
          <p class="noticeTitle" :class="scope.row.fReadStatus == 1 ? 'read':''" @click="toDetails(scope.row)">商户{{ scope.row.fMerchantName }}&nbsp;&nbsp;的风控审核
            <span v-if="scope.row.auditStatus == 1">待提交</span>
            <span v-if="scope.row.auditStatus == 2">正在审核中</span>
            <span v-if="scope.row.auditStatus == 3">审核未通过</span>
            <span v-if="scope.row.auditStatus == 4">审核通过</span>
            <span v-if="scope.row.auditStatus == 5">审核终止</span>
          </p>
        </template>
      </el-table-column>
      <el-table-column prop="fCreateTime" width="160">
        <template slot-scope="scope">
          <span :class="scope.row.fReadStatus == 1 ? 'read':''">{{ scope.row.fCreateTime }}</span>
        </template>
      </el-table-column>
    </el-table>
    <el-col :span="24" class="btm-action">
      <el-pagination
        v-if="paginations.count > 0"
        class="pagination"
        :page-size="paginations.pageSize"
        layout="total, prev, pager, next, jumper"
        :total="paginations.count"
        :current-page="paginations.pageNo"
        @current-change="onChangeCurrentPage">
      </el-pagination>
    </el-col>
  </div>
</template>

<script>
import qs from 'qs'
import { riskOperFlows, updateReadState } from '@/api/home'
import { parseAuditStatus } from '@/utils/parseData'
export default {
  name: 'Notice',
  data () {
    return {
      noticeNum: 100,
      noticeList: [],
      loading: false,
      // 需要给分页组件传的信息
      paginations: {
        pageNo: 1,
        count: 0,
        pageSize: 10
      }
    }
  },
  mounted () {
    this.getList()
  },
  computed: {
    notReadNum () {
      if (this.noticeNum <= 99) {
        return this.noticeNum
      } else {
        return '99+'
      }
    }
  },
  methods: {
    getList () {
      var data = {
        pageNo: this.paginations.pageNo,
        pageSize: this.paginations.pageSize,
        count: this.paginations.count
      }
      data = qs.stringify(data)
      riskOperFlows(data).then(data => {
        if (parseInt(data.error_code) !== 0) {
          this.$message({
            showClose: true,
            message: data.error_msg,
            type: 'error'
          })
        } else {
          this.noticeList = data.data.list.map(item => {
            item.auditStatus = parseAuditStatus(item.fTicketStatus, item.fMtlVerifyStatus)
            return item
          })
          this.noticeNum = data.data.totalCount
          this.paginations.count = data.data.totalCount
        }
      }).catch(() => {
      })
    },
    /**
             * @description 改变当前页事件
             * @param  {number} page 当前页码
             */
    onChangeCurrentPage (page) {
      this.paginations.pageNo = page
      this.getList()
    },
    toDetails (row) {
      var data = {
        flowId: row.fId
      }
      data = qs.stringify(data)
      updateReadState(data).then(data => {
        if (parseInt(data.error_code) !== 0) {
          this.$message({
            showClose: true,
            message: data.error_msg,
            type: 'error'
          })
        } else {

        }
      })
      this.$router.push('/Risk/RiskManage/checkDetails/' + row.fTicketNumber)
    }
  }
}
</script>

<style scoped>
    .main-view {
        padding: 16px;
    }
    .noticeTitle{
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        text-decoration: underline;
        cursor: pointer;
        margin: 0;
    }
    .read{
        color: #999;
    }
    .table {
        border: 1px solid #ebeef5;
    }
    .btm-action{
        text-align: center;
        margin-top: 20px;
    }
</style>
